import React, { useState, useEffect, useRef } from 'react';
import { FiMoreVertical, FiSearch, FiMessageSquare, FiUser, FiPaperclip, FiMic, FiSmile, FiVideo, FiUserPlus, FiUsers, FiPhone, FiPhoneCall, FiPhoneOff, FiMapPin, FiMail, FiGlobe, FiBriefcase, FiBuilding, FiTag, FiAward, FiExternalLink, FiGrid, FiList, FiCheck } from 'react-icons/fi';
import { BsCheck2All, BsThreeDotsVertical, BsPinAngle, BsTag, BsPinAngleFill, BsPerson, BsBuilding, BsTelephone, BsEnvelope, BsGeoAlt, BsGlobe, BsBriefcase, BsCardText, BsAward } from 'react-icons/bs';
import { IoMdSend } from 'react-icons/io';
import { RiChatNewLine } from 'react-icons/ri';
import { MdOutlineEmojiEmotions, MdOutlineFileUpload, MdBusiness, MdLocationOn, MdEmail, MdLanguage, MdWork, MdAccountBalance, MdSell, MdInfo } from 'react-icons/md';
import axios from 'axios';
import authStorage from '../../utilities/Storage';
import Header from "../Header";
import Sidebar from "../SideBar";
import Content from '../Content';
import ReactQuill from 'react-quill';
import Linkify from 'linkify-react';
import 'react-quill/dist/quill.snow.css';
import { Tooltip, OverlayTrigger, Modal, Button, Form, Dropdown, Badge, Tabs, Tab, Card, Accordion } from 'react-bootstrap';
import { format, isToday, isYesterday } from 'date-fns';
import Logo from "../../components/assets/EABC-LOGO-PNG-1-600x605-1-400x403.png";
import { useNavigate } from 'react-router-dom';

// Define polling interval at the top of your file
const MESSAGE_POLL_INTERVAL = 2000; // 2 seconds

// Component for user initials avatar
const UserInitialsAvatar = ({ name, size = 48, className = "" }) => {
  const getInitials = (name) => {
    if (!name) return "U";
    
    const parts = name.split(" ");
    if (parts.length >= 2) {
      return parts[0].charAt(0).toUpperCase() + parts[1].charAt(0).toUpperCase();
    } else {
      return name.substring(0, 2).toUpperCase();
    }
  };
  
  const getAvatarColor = (name) => {
    if (!name) return "#6c757d";
    
    const colors = [
      "#FF8C00", // Orange
      "#8B008B", // Purple
      "#0000FF", // Blue
      "#8B4513", // Brown
      "#87CEEB", // Light Blue
      "#228B22", // Green
      "#4361ee", "#3f37c9", "#f72585", "#b5179e", "#7209b7",
      "#560bad", "#480ca8", "#3a0ca3", "#3f37c9", "#4361ee",
      "#4895ef", "#4cc9f0", "#00b4d8", "#0077b6", "#023e8a",
      "#03045e", "#e63946", "#f1faee", "#a8dadc", "#457b9d"
    ];
    
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    
    return colors[Math.abs(hash) % colors.length];
  };
  
  return (
    <div
      className={`rounded-circle d-flex align-items-center justify-content-center text-white fw-bold ${className}`}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        backgroundColor: getAvatarColor(name),
        fontSize: `${size / 2.5}px`,
        flexShrink: 0,
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}
    >
      {getInitials(name)}
    </div>
  );
};

// Component for user card with different view modes
const UserCard = ({ user, onlineUsers, activeChat, setActiveChat, initiateCall, setProfileUser, loadProfileDetails, setShowUserProfile, toggleUserExpanded }) => {
  const [viewMode, setViewMode] = useState('compact'); // compact, detailed, grid
  
  const handleCardClick = () => {
    setActiveChat(user.id);
  };
  
  const handleProfileClick = (e) => {
    e.stopPropagation();
    setProfileUser(user);
    loadProfileDetails(user.email, user.company_name);
    setShowUserProfile(true);
  };
  
  const handleChatClick = (e) => {
    e.stopPropagation();
    setActiveChat(user.id);
  };
  
  const handleCallClick = (e) => {
    e.stopPropagation();
    initiateCall(user.id);
  };
  
  const handleExpandClick = (e) => {
    e.stopPropagation();
    toggleUserExpanded(user.id);
  };
  
  const handleViewModeChange = (mode) => {
    setViewMode(mode);
  };
  
  // Render compact view
  const renderCompactView = () => (
    <div className="d-flex align-items-center p-3 user-card-compact">
      <div className="position-relative me-3">
        <UserInitialsAvatar name={user.full_name} size={48} className="border" />
        {onlineUsers.includes(user.id) && (
          <span className="position-absolute bottom-0 end-0 bg-success rounded-circle border border-2 border-white" 
                style={{ width: "13px", height: "13px" }}></span>
        )}
      </div>
      
      <div className="flex-grow-1">
        <div className="d-flex align-items-center flex-wrap gap-2">
          <span className="fw-semibold">{user.full_name}</span>
          
          {user.company_name && (
            <span className="badge bg-light text-dark border">{user.company_name}</span>
          )}
          
          {user.country && (
            <span className="badge bg-secondary">({user.country})</span>
          )}
          
          {user.unread_count > 0 && (
            <span className="badge bg-danger">{user.unread_count} new</span>
          )}
        </div>
        
        <div className="text-muted small mt-1">
          {user.email}
          {user.phone && <span className="ms-2">• {user.phone}</span>}
        </div>
        
        {user.position && (
          <div className="small text-muted mt-1">
            <FiBriefcase className="me-1" size={12} />
            {user.position}
          </div>
        )}

        <div className="mt-2">
                  <div className="mb-3">
                    <div className="small text-muted mb-1">B2B Interests</div>
                    <div className="d-flex flex-wrap gap-1">
                      {user.b2b_interest && user.b2b_interest.length > 0 ? (
                        user.b2b_interest.map((interest, index) => (
                          <span key={index} className="badge bg-primary">{interest}</span>
                        ))
                      ) : (
                        <span className="small text-muted">No B2B interests</span>
                      )}
                    </div>
                  </div>
                  
                  <div className="mb-3">
                    <div className="small text-muted mb-1">B2B Details</div>
                    <div className="small">{user.b2b_details || 'N/A'}</div>
                  </div>
                  
                  <div className="mb-3">
                    <div className="small text-muted mb-1">Products & Services</div>
                    <div className="small">{user.products_services || 'N/A'}</div>
                  </div>
                </div>
      </div>
      
      <div className="d-flex flex-column align-items-end gap-1">
        <button className="btn btn-sm btn-outline-primary" title="View Profile" onClick={handleProfileClick}>
          <BsPerson />
        </button>
        <button className="btn btn-sm btn-outline-success" title="Chat" onClick={handleChatClick}>
          <FiMessageSquare />
        </button>
        <button className="btn btn-sm btn-outline-info" title="Video Call" onClick={handleCallClick}>
          <FiVideo />
        </button>
      </div>
    </div>
  );
  
  // Render detailed view
  const renderDetailedView = () => (
    <div className="p-3 user-card-detailed">
      <div className="d-flex align-items-start mb-3">
        <div className="position-relative me-3">
          <UserInitialsAvatar name={user.full_name} size={60} className="border" />
          {onlineUsers.includes(user.id) && (
            <span className="position-absolute bottom-0 end-0 bg-success rounded-circle border border-2 border-white" 
                  style={{ width: "15px", height: "15px" }}></span>
          )}
        </div>
        
        <div className="flex-grow-1">
          <h5 className="mb-1">{user.full_name}</h5>
          <div className="d-flex align-items-center flex-wrap gap-2 mb-2">
            {user.company_name && (
              <span className="badge bg-primary">{user.company_name}</span>
            )}
            {user.position && (
              <span className="badge bg-info">{user.position}</span>
            )}
            {user.country && (
              <span className="badge bg-secondary">{user.country}</span>
            )}
            {user.participation_type && (
              <span className="badge bg-warning text-dark">{user.participation_type}</span>
            )}
          </div>
          
          <div className="text-muted small">
            <FiMail className="me-1" size={12} />
            {user.email}
            {user.phone && <span className="ms-3"><FiPhone className="me-1" size={12} />{user.phone}</span>}
          </div>
        </div>
        
        <div className="d-flex flex-column align-items-end gap-1">
          <button className="btn btn-sm btn-outline-primary" title="View Profile" onClick={handleProfileClick}>
            <BsPerson />
          </button>
          <button className="btn btn-sm btn-outline-success" title="Chat" onClick={handleChatClick}>
            <FiMessageSquare />
          </button>
          <button className="btn btn-sm btn-outline-info" title="Video Call" onClick={handleCallClick}>
            <FiVideo />
          </button>
        </div>
      </div>
      
      <div className="row g-2">
        <div className="col-md-6">
          <div className="d-flex align-items-center mb-2">
            <BsBuilding className="me-2 text-primary" />
            <div>
              <div className="small text-muted">Organization</div>
              <div className="small fw-medium">{user.organization || 'N/A'}</div>
            </div>
          </div>
          
          <div className="d-flex align-items-center mb-2">
            <BsBriefcase className="me-2 text-primary" />
            <div>
              <div className="small text-muted">Title</div>
              <div className="small fw-medium">{user.title || 'N/A'}</div>
            </div>
          </div>
          
          <div className="d-flex align-items-center mb-2">
            <BsGeoAlt className="me-2 text-primary" />
            <div>
              <div className="small text-muted">Company Address</div>
              <div className="small fw-medium">{user.company_address || 'N/A'}</div>
            </div>
          </div>
          
          <div className="d-flex align-items-center mb-2">
            <BsTelephone className="me-2 text-primary" />
            <div>
              <div className="small text-muted">Company Phone</div>
              <div className="small fw-medium">{user.company_phone || 'N/A'}</div>
            </div>
          </div>
        </div>
        
        <div className="col-md-6">
          <div className="d-flex align-items-center mb-2">
            <BsGlobe className="me-2 text-primary" />
            <div>
              <div className="small text-muted">Company Website</div>
              {user.company_website ? (
                <a href={user.company_website} target="_blank" rel="noopener noreferrer" className="small fw-medium text-primary">
                  {user.company_website.length > 25 ? user.company_website.substring(0, 25) + '...' : user.company_website}
                </a>
              ) : (
                <div className="small fw-medium">N/A</div>
              )}
            </div>
          </div>
          
          <div className="d-flex align-items-center mb-2">
            <BsAward className="me-2 text-primary" />
            <div>
              <div className="small text-muted">Sponsorship Interest</div>
              <div className="small fw-medium">{user.sponsorship_interest ? 'Yes' : 'No'}</div>
            </div>
          </div>
          
          <div className="d-flex align-items-center mb-2">
            <BsCardText className="me-2 text-primary" />
            <div>
              <div className="small text-muted">Company Sector</div>
              <div className="small fw-medium">{user.company_sector || 'N/A'}</div>
            </div>
          </div>
          
          <div className="d-flex align-items-center mb-2">
            <BsTag className="me-2 text-primary" />
            <div>
              <div className="small text-muted">Exhibit Booth</div>
              <div className="small fw-medium">{user.exhibit_booth || 'N/A'}</div>
            </div>
          </div>
        </div>
      </div>
      
      {user.b2b_interest && user.b2b_interest.length > 0 && (
        <div className="mt-2">
          <div className="small text-muted mb-1">B2B Interests</div>
          <div className="d-flex flex-wrap gap-1">
            {user.b2b_interest.slice(0, 5).map((interest, index) => (
              <span key={index} className="badge bg-light text-dark">{interest}</span>
            ))}
            {user.b2b_interest.length > 5 && (
              <span className="badge bg-light text-dark">+{user.b2b_interest.length - 5}</span>
            )}
          </div>
        </div>
      )}
      
      {user.b2b_details && (
        <div className="mt-2">
          <div className="small text-muted mb-1">B2B Details</div>
          <div className="small text-truncate" title={user.b2b_details}>
            {user.b2b_details.length > 100 ? user.b2b_details.substring(0, 100) + '...' : user.b2b_details}
          </div>
        </div>
      )}
    </div>
  );
  
  // Render grid view
  const renderGridView = () => (
    <div className="p-3 user-card-grid">
      <div className="text-center mb-3">
        <div className="position-relative d-inline-block">
          <UserInitialsAvatar name={user.full_name} size={80} className="border" />
          {onlineUsers.includes(user.id) && (
            <span className="position-absolute bottom-0 end-0 bg-success rounded-circle border border-2 border-white" 
                  style={{ width: "18px", height: "18px" }}></span>
          )}
        </div>
        
        <h5 className="mt-2 mb-1">{user.full_name}</h5>
        
        {user.company_name && (
          <div className="badge bg-primary mb-2">{user.company_name}</div>
        )}
        
        <div className="text-muted small mb-2">
          {user.email}
        </div>
        
        <div className="d-flex justify-content-center gap-2">
          <button className="btn btn-sm btn-outline-primary" title="View Profile" onClick={handleProfileClick}>
            <BsPerson />
          </button>
          <button className="btn btn-sm btn-outline-success" title="Chat" onClick={handleChatClick}>
            <FiMessageSquare />
          </button>
          <button className="btn btn-sm btn-outline-info" title="Video Call" onClick={handleCallClick}>
            <FiVideo />
          </button>
        </div>
      </div>
      
      <div className="user-grid-details">
        <div className="row g-2">
          <div className="col-6">
            <div className="small text-muted">Position</div>
            <div className="small fw-medium">{user.position || 'N/A'}</div>
          </div>
          <div className="col-6">
            <div className="small text-muted">Country</div>
            <div className="small fw-medium">{user.country || 'N/A'}</div>
          </div>
          <div className="col-6">
            <div className="small text-muted">Organization</div>
            <div className="small fw-medium">{user.organization || 'N/A'}</div>
          </div>
          <div className="col-6">
            <div className="small text-muted">Company Sector</div>
            <div className="small fw-medium">{user.company_sector || 'N/A'}</div>
          </div>
        </div>
      </div>
    </div>
  );
  
  return (
    <div 
      className={`card mb-3 border-0 shadow-sm user-card-hover ${
        activeChat === user.id 
          ? "active-user-card border-primary border-3" 
          : ""
      }`}
      style={{ cursor: "pointer" }}
      onClick={handleCardClick}
    >
      <div className="card-body p-0">
        {/* Active user indicator - top left corner */}
        {activeChat === user.id && (
          <div className="active-user-indicator position-absolute top-0 start-0 d-flex align-items-center justify-content-center">
            <FiCheck className="text-white" size={12} />
            <span className="ms-1 text-white fw-bold small">Active</span>
          </div>
        )}
        
        {/* View mode selector */}
        <div className="d-flex justify-content-end p-2 border-bottom">
          <div className="btn-group btn-group-sm" role="group">
            <button 
              type="button" 
              className={`btn btn-outline-secondary ${viewMode === 'compact' ? 'active' : ''}`}
              onClick={() => handleViewModeChange('compact')}
            >
              <FiList />
            </button>
            <button 
              type="button" 
              className={`btn btn-outline-secondary ${viewMode === 'detailed' ? 'active' : ''}`}
              onClick={() => handleViewModeChange('detailed')}
            >
              <FiGrid />
            </button>
          </div>
        </div>
        
        {/* Render content based on view mode */}
        {viewMode === 'compact' && renderCompactView()}
        {viewMode === 'detailed' && renderDetailedView()}
        {viewMode === 'grid' && renderGridView()}
        
        {/* Show more/less toggle for compact view */}
        {viewMode === 'compact' && (
          <div className="text-center p-2 border-top">
            <button
              className="btn btn-sm text-primary p-0"
              onClick={handleExpandClick}
            >
              {user.expanded ? 'Show less' : 'Show more'}
            </button>
          </div>
        )}
        
        {/* Expanded details for compact view */}
        {viewMode === 'compact' && user.expanded && (
          <div className="p-3 border-top bg-light">
            <Tabs defaultActiveKey="personal" className="mb-3">
              <Tab eventKey="personal" title="Personal">
                <div className="row g-2 mt-2">
                  <div className="col-md-6">
                    <div className="d-flex align-items-center mb-2">
                      <BsEnvelope className="me-2 text-primary" />
                      <div>
                        <div className="small text-muted">Email</div>
                        <div className="small fw-medium">{user.email || 'N/A'}</div>
                      </div>
                    </div>
                    
                    <div className="d-flex align-items-center mb-2">
                      <BsTelephone className="me-2 text-primary" />
                      <div>
                        <div className="small text-muted">Phone</div>
                        <div className="small fw-medium">{user.phone || 'N/A'}</div>
                      </div>
                    </div>
                    
                    <div className="d-flex align-items-center mb-2">
                      <BsGeoAlt className="me-2 text-primary" />
                      <div>
                        <div className="small text-muted">Country</div>
                        <div className="small fw-medium">{user.country || 'N/A'}</div>
                      </div>
                    </div>
                  </div>
                  
                  <div className="col-md-6">
                    <div className="d-flex align-items-center mb-2">
                      <BsBuilding className="me-2 text-primary" />
                      <div>
                        <div className="small text-muted">Organization</div>
                        <div className="small fw-medium">{user.organization || 'N/A'}</div>
                      </div>
                    </div>
                    
                    <div className="d-flex align-items-center mb-2">
                      <BsBriefcase className="me-2 text-primary" />
                      <div>
                        <div className="small text-muted">Position</div>
                        <div className="small fw-medium">{user.position || 'N/A'}</div>
                      </div>
                    </div>
                    
                    <div className="d-flex align-items-center mb-2">
                      <BsAward className="me-2 text-primary" />
                      <div>
                        <div className="small text-muted">Title</div>
                        <div className="small fw-medium">{user.title || 'N/A'}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </Tab>
              
              <Tab eventKey="company" title="Company">
                <div className="row g-2 mt-2">
                  <div className="col-md-6">
                    <div className="d-flex align-items-center mb-2">
                      <BsBuilding className="me-2 text-primary" />
                      <div>
                        <div className="small text-muted">Company Name</div>
                        <div className="small fw-medium">{user.company_name || 'N/A'}</div>
                      </div>
                    </div>
                    
                    <div className="d-flex align-items-center mb-2">
                      <BsGeoAlt className="me-2 text-primary" />
                      <div>
                        <div className="small text-muted">Company Address</div>
                        <div className="small fw-medium">{user.company_address || 'N/A'}</div>
                      </div>
                    </div>
                    
                    <div className="d-flex align-items-center mb-2">
                      <BsTelephone className="me-2 text-primary" />
                      <div>
                        <div className="small text-muted">Company Phone</div>
                        <div className="small fw-medium">{user.company_phone || 'N/A'}</div>
                      </div>
                    </div>
                  </div>
                  
                  <div className="col-md-6">
                    <div className="d-flex align-items-center mb-2">
                      <BsGlobe className="me-2 text-primary" />
                      <div>
                        <div className="small text-muted">Company Website</div>
                        {user.company_website ? (
                          <a href={user.company_website} target="_blank" rel="noopener noreferrer" className="small fw-medium text-primary">
                            {user.company_website.length > 25 ? user.company_website.substring(0, 25) + '...' : user.company_website}
                          </a>
                        ) : (
                          <div className="small fw-medium">N/A</div>
                        )}
                      </div>
                    </div>
                    
                    <div className="d-flex align-items-center mb-2">
                      <BsCardText className="me-2 text-primary" />
                      <div>
                        <div className="small text-muted">Company Sector</div>
                        <div className="small fw-medium">{user.company_sector || 'N/A'}</div>
                      </div>
                    </div>
                    
                    <div className="d-flex align-items-center mb-2">
                      <BsTag className="me-2 text-primary" />
                      <div>
                        <div className="small text-muted">Exhibit Booth</div>
                        <div className="small fw-medium">{user.exhibit_booth || 'N/A'}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </Tab>
              
              <Tab eventKey="b2b" title="B2B">
                <div className="mt-2">
                  <div className="mb-3">
                    <div className="small text-muted mb-1">B2B Interests</div>
                    <div className="d-flex flex-wrap gap-1">
                      {user.b2b_interest && user.b2b_interest.length > 0 ? (
                        user.b2b_interest.map((interest, index) => (
                          <span key={index} className="badge bg-primary">{interest}</span>
                        ))
                      ) : (
                        <span className="small text-muted">No B2B interests</span>
                      )}
                    </div>
                  </div>
                  
                  <div className="mb-3">
                    <div className="small text-muted mb-1">B2B Details</div>
                    <div className="small">{user.b2b_details || 'N/A'}</div>
                  </div>
                  
                  <div className="mb-3">
                    <div className="small text-muted mb-1">Products & Services</div>
                    <div className="small">{user.products_services || 'N/A'}</div>
                  </div>
                  
                  <div className="mb-3">
                    <div className="small text-muted mb-1">Company Profile</div>
                    <div className="small">{user.company_profile || 'N/A'}</div>
                  </div>
                </div>
              </Tab>
            </Tabs>
          </div>
        )}
      </div>
    </div>
  );
};

export default function CommunityChat() {
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState('');
  const [activeChat, setActiveChat] = useState('Community');
  const [users, setUsers] = useState([]);
  const [loadingUsers, setLoadingUsers] = useState(true);
  const [userError, setUserError] = useState(null);
  const [messageError, setMessageError] = useState(null);
  const [userEmail, setUserEmail] = useState('');
  const [chatType, setChatType] = useState('community');
  const [chatParticipants, setChatParticipants] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [pinnedMessages, setPinnedMessages] = useState([]);
  const [showPinnedMessages, setShowPinnedMessages] = useState(false);
  const [showUserProfile, setShowUserProfile] = useState(false);
  const [profileUser, setProfileUser] = useState(null);
  const [typingUsers, setTypingUsers] = useState([]);
  const [isTyping, setIsTyping] = useState(false);
  const [onlineUsers, setOnlineUsers] = useState([]);
  const [profileData, setProfileData] = useState({});
  const [profileProducts, setProfileProducts] = useState([]);
  const [profileServices, setProfileServices] = useState([]);
  const [loadingMessages, setLoadingMessages] = useState(true);
  const [activeCall, setActiveCall] = useState(null);
  const [callStatus, setCallStatus] = useState('idle'); // idle, calling, connected, ended
  const [showFullProfile, setShowFullProfile] = useState(false);
  const [listViewMode, setListViewMode] = useState('compact'); // compact, detailed, grid
  const messagesEndRef = useRef(null);
  const typingTimeoutRef = useRef(null);
  const navigate = useNavigate();
  const messageFetchRef = useRef(false);

  // Get user email from storage
  useEffect(() => {
    const getUserEmail = () => {
      const userData = authStorage.getUser();
      if (userData) {
        try {
          const user = JSON.parse(userData);
          setUserEmail(user.email);
        } catch (error) {
          setUserError("Failed to load user data");
        }
      }
    };
    getUserEmail();
  }, []);

  // Fetch users from backend
  useEffect(() => {
    if (!userEmail) return;
    const fetchUsers = async () => {
      try {
        setLoadingUsers(true);
        const response = await axios.get('https://backend-livestream-production.up.railway.app/api/get-userbyEmail', {
          params: { email: userEmail }
        });
        if (response.data && Array.isArray(response.data.data)) {
          const formattedUsers = response.data.data.map(user => {
            // Parse b2b_interest if it's a string
            let b2bInterests = [];
            if (user.b2b_interest) {
              if (typeof user.b2b_interest === 'string') {
                try {
                  b2bInterests = JSON.parse(user.b2b_interest);
                } catch (e) {
                  // If parsing fails, treat as a single interest
                  b2bInterests = [user.b2b_interest];
                }
              } else if (Array.isArray(user.b2b_interest)) {
                b2bInterests = user.b2b_interest;
              }
            }
            
            return {
              id: user.id || user._id,
              email: user.email,
              company_email: user.company_email || user.email, // Added company_email
              company_name: user.company_name || '',
              title: user.title || '',
              full_name: user.full_name || user.name || 'Unknown User',
              position: user.position || '',
              organization: user.organization || '',
              phone: user.phone || '',
              country: user.country || '',
              participation_type: user.participation_type || '',
              exhibit_booth: user.exhibit_booth || '',
              b2b_interest: b2bInterests,
              b2b_details: user.b2b_details || '',
              company_profile: user.company_profile || '',
              company_sector: user.company_sector || '',
              products_services: user.products_services || '',
              company_address: user.company_address || '',
              company_phone: user.company_phone || '',
              company_website: user.company_website || '',
              social_media: user.social_media || '',
              sponsorship_interest: user.sponsorship_interest || false,
              avatar: user.avatar || user.logo_url,
              last_message_time: user.last_message_time || new Date(),
              last_message: user.last_message || 'No messages yet',
              unread_count: user.unread_count || 0,
              status: 'online',
              full_profile: user, // Store the full profile data
              expanded: false // Initialize expanded state to false
            };
          });
          setUsers(formattedUsers);
          setOnlineUsers(response.data.data.slice(0, 3).map(u => u.id || u._id));
        } else {
          setUsers([]);
        }
        setUserError(null);
      } catch (err) {
        setUserError("Failed to load users. Please try again.");
        setUsers([]);
      } finally {
        setLoadingUsers(false);
      }
    };
    fetchUsers();
  }, [userEmail]);

  // Real-time polling for messages, but avoid flicker: "preserve" old messages until new ones are in.
  useEffect(() => {
    if (!userEmail) return;
    let timer;
    let stopped = false;
    let lastIds = [];
    let firstLoad = true;

    const fetchMessages = async () => {
      try {
        const response = await axios.get('https://backend-livestream-production.up.railway.app/api/get-messages', {
          params: {
            email: userEmail,
            chat_id: activeChat === 'Community' ? 'community' : activeChat,
            include_sent: true
          }
        });
    
        let formattedMessages = [];
        if (response.data && Array.isArray(response.data.data)) {
          formattedMessages = response.data.data.map(msg => ({
            id: msg.id || msg._id || Date.now(),
            sender: msg.sender_name || 'Unknown',
            sender_email: msg.sender_email,
            receiver_email: msg.receiver_email,
            avatar: msg.sender_avatar || `https://ui-avatars.com/api/?name=${msg.sender_name || 'U'}`,
            text: msg.message || '',
            time: format(new Date(msg.timestamp), 'h:mm a'),
            timestamp: new Date(msg.timestamp),
            read: msg.read_status || false,
            sent: msg.sender_email === userEmail,
            chat_type: msg.chat_type || (activeChat === 'Community' ? 'community' : 'private'),
            direction: msg.sender_email === userEmail ? 'sent' : 'received',
            company_name: msg.sender_company || '',
            is_call_notification: msg.is_call_notification || false,
            call_link: msg.call_link || null
          }));
        }
    
        // Only update if messages changed
        const newIds = formattedMessages.map(m => m.id).join(',');
        if (newIds !== lastIds.join(',')) {
          setMessages(formattedMessages);
          lastIds = formattedMessages.map(m => m.id);
        }
        setLoadingMessages(false);
        firstLoad = false;
      } catch (err) {
        setMessageError(err.message || "Failed to load messages. Please try again.");
        setLoadingMessages(false);
      }
    };
    
    setLoadingMessages(true);
    fetchMessages();
    timer = setInterval(() => {
      if (!stopped) fetchMessages();
    }, MESSAGE_POLL_INTERVAL);
    
    return () => {
      stopped = true;
      clearInterval(timer);
    };
  }, [userEmail, activeChat, users.length]);

  // Scroll to bottom of messages
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages.length]);

  // Simulate typing indicators
  useEffect(() => {
    if (activeChat === 'Community') {
      const interval = setInterval(() => {
        const randomUser = users[Math.floor(Math.random() * users.length)];
        if (randomUser && !typingUsers.includes(randomUser.id)) {
          setTypingUsers(prev => [...prev, randomUser.id]);
          setTimeout(() => {
            setTypingUsers(prev => prev.filter(id => id !== randomUser.id));
          }, 2000 + Math.random() * 3000);
        }
      }, 8000);
      return () => clearInterval(interval);
    }
  }, [activeChat, users]);

  const loadProfileDetails = async (userEmail, userCompany) => {
    try {
      const personalResponse = await axios.get('https://backend-livestream-production.up.railway.app/api/get-personal-detail-by-email-company-name', {
        params: { email: userEmail, company_name: userCompany }
      });
      setProfileData(personalResponse.data.data[0] || {});

      const productsResponse = await axios.get('https://backend-livestream-production.up.railway.app/api/get-products', {
        params: { email: userEmail, company_name: userCompany }
      });
      setProfileProducts(productsResponse.data.data || []);
    
      const servicesResponse = await axios.get('https://backend-livestream-production.up.railway.app/api/get-services', {
        params: { email: userEmail, company_name: userCompany }
      });
      setProfileServices(servicesResponse.data.data || []);
    } catch (error) {}
  };

  // Real-time: send and receive without refresh
  const handleSendMessage = async (e) => {
    e.preventDefault();
    if (newMessage.trim() === '') return;

    const tempId = Date.now() + Math.random();
    try {
      const receiverEmail = activeChat === 'Community' ? 'community' : users.find(u => u.id === activeChat)?.email;
      const senderName = users.find(u => u.email === userEmail)?.full_name || 'You';

      setMessages(prev => [
        ...prev,
        {
          id: tempId,
          sender: senderName,
          sender_email: userEmail,
          receiver_email: receiverEmail,
          avatar: users.find(u => u.email === userEmail)?.avatar || `https://ui-avatars.com/api/?name=${senderName}`,
          text: newMessage,
          time: format(new Date(), 'h:mm a'),
          timestamp: new Date(),
          read: false,
          sent: true,
          chat_type: activeChat === 'Community' ? 'community' : 'private',
          direction: 'sent'
        }
      ]);
      setNewMessage('');
      setIsTyping(false);

      await axios.post('https://backend-livestream-production.up.railway.app/api/send-message', {
        messageId: tempId,
        chat_id: activeChat === 'Community' ? 'community' : activeChat,
        sender: senderName,
        sender_email: userEmail,
        receiver_email: receiverEmail,
        avatar: users.find(u => u.email === userEmail)?.avatar || `https://ui-avatars.com/api/?name=${senderName}`,
        message: newMessage,
        time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
        timestamp: new Date(),
        read: false,
        sent: false,
        chat_type: activeChat === 'Community' ? 'community' : 'private'
      });
      // No need to immediately update again, polling will pick up the confirmed message.
    } catch (error) {
      setMessageError(error.response?.data?.message || "Failed to send message. Please try again.");
      setMessages(prev => prev.filter(msg => msg.id !== tempId));
    }
  };

  const handleTyping = () => {
    setIsTyping(true);
    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current);
    }
    typingTimeoutRef.current = setTimeout(() => {
      setIsTyping(false);
    }, 2000);
  };

  // Simplified startMeeting function - creates meeting immediately
  const startMeeting = async (isVideo = true) => {
    try {
      // Generate a unique room name
      const roomName = `meeting-${Date.now()}`;
      const meetingLink = `${window.location.origin}/meeting/${roomName}?media=${isVideo ? 'video' : 'audio'}`;
      
      // Create meeting with default values
      const response = await fetch('https://backend-livestream-production.up.railway.app/api/meetings', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: userEmail.trim(),
          meetingName: `Quick ${isVideo ? 'Video' : 'Audio'} Meeting`,
          roomName,
          meetingLink,
          status: 'ongoing' // Set status to ongoing since meeting starts immediately
        }),
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || 'Failed to create meeting');
      }

      // Get sender details
      const senderName = users.find(u => u.email === userEmail)?.full_name || 'You';
      const senderAvatar = users.find(u => u.email === userEmail)?.avatar || `https://ui-avatars.com/api/?name=${senderName}`;
      
      // Create meeting notification message
      const meetingMessage = `${senderName} started a ${isVideo ? 'video' : 'audio'} meeting. Join here: ${meetingLink}`;
      
      // Send notification to community chat
      if (activeChat === 'Community') {
        try {
          await axios.post('https://backend-livestream-production.up.railway.app/api/send-message', {
            messageId: Date.now(),
            chat_id: 'community',
            sender: senderName,
            sender_email: userEmail,
            receiver_email: 'community',
            avatar: senderAvatar,
            message: meetingMessage,
            time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
            timestamp: new Date(),
            read: false,
            sent: false,
            chat_type: 'community'
          });
        } catch (error) {
          console.error('Failed to send message to community:', error);
        }
      }

      // Navigate to the meeting room
      navigate(`/meeting/${roomName}?media=${isVideo ? 'video' : 'audio'}`);

    } catch (error) {
      console.error('Error creating meeting:', error);
      alert('Failed to create meeting. Please try again.');
    }
  };

  const pinMessage = (messageId) => {
    const messageToPin = messages.find(msg => msg.id === messageId);
    if (messageToPin && !pinnedMessages.some(msg => msg.id === messageId)) {
      setPinnedMessages([...pinnedMessages, messageToPin]);
    }
  };

  const unpinMessage = (messageId) => {
    setPinnedMessages(pinnedMessages.filter(msg => msg.id !== messageId));
  };

  // Enhanced search functionality
  const filteredUsers = users.filter(user => {
    if (user.email === userEmail) return false; // Exclude current user
    
    const query = searchQuery.toLowerCase();
    
    // Check if query matches any of the user fields
    const matchesName = user.full_name.toLowerCase().includes(query);
    const matchesEmail = user.email.toLowerCase().includes(query);
    const matchesCompany = user.company_name && user.company_name.toLowerCase().includes(query);
    const matchesPosition = user.position && user.position.toLowerCase().includes(query);
    const matchesCountry = user.country && user.country.toLowerCase().includes(query);
    const matchesSector = user.company_sector && user.company_sector.toLowerCase().includes(query);
    
    // Check if query matches any B2B interest
    const matchesB2B = user.b2b_interest && user.b2b_interest.some(interest => 
      typeof interest === 'string' && interest.toLowerCase().includes(query)
    );
    
    return matchesName || matchesEmail || matchesCompany || matchesPosition || 
           matchesCountry || matchesSector || matchesB2B;
  });

  // Direct call functionality - MODIFIED
  const initiateCall = (userId) => {
    const user = users.find(u => u.id === userId);
    if (!user) return;
    
    // Create a unique room name for this call
    const roomName = `call-${userEmail}-${user.email}-${Date.now()}`;
    
    // Create a call notification message
    const callMessage = `${users.find(u => u.email === userEmail)?.full_name || 'Someone'} is calling you. Join here: ${window.location.origin}/meeting/${roomName}?media=video`;
    
    // Send notification to the called user
    axios.post('https://backend-livestream-production.up.railway.app/api/send-message', {
      messageId: Date.now(),
      chat_id: userId,
      sender: users.find(u => u.email === userEmail)?.full_name || 'You',
      sender_email: userEmail,
      receiver_email: user.email,
      avatar: users.find(u => u.email === userEmail)?.avatar || `https://ui-avatars.com/api/?name=${users.find(u => u.email === userEmail)?.full_name || 'You'}`,
      message: callMessage,
      time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
      timestamp: new Date(),
      read: false,
      sent: false,
      chat_type: 'private',
      is_call_notification: true,
      call_link: `${window.location.origin}/meeting/${roomName}?media=video`
    }).then(() => {
      // Navigate to the meeting room
      navigate(`/meeting/${roomName}?media=video`);
    }).catch(error => {
      console.error('Failed to send call notification:', error);
      alert('Failed to initiate call. Please try again.');
    });
  };
  
  const endCall = () => {
    setCallStatus('ended');
    
    // Reset call state after a short delay
    setTimeout(() => {
      setActiveCall(null);
      setCallStatus('idle');
    }, 1000);
  };

  const formatMessageTime = (date) => {
    if (isToday(new Date(date))) {
      return format(new Date(date), 'h:mm a');
    } else if (isYesterday(new Date(date))) {
      return 'Yesterday';
    } else {
      return format(new Date(date), 'MMM d');
    }
  };

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {props.text}
    </Tooltip>
  );

  const renderField = (icon, label, value) => (
    <div className="d-flex mb-3">
      <div className="me-3">
        <div className="bg-light rounded-circle p-2">
          <i className={`bi bi-${icon} text-primary`}></i>
        </div>
      </div>
      <div>
        <small className="text-muted">{label}</small>
        <p className="mb-0">{value || 'Not provided'}</p>
      </div>
    </div>
  );

  const renderUserProfile = () => {
    if (!profileUser) return null;
    return (
      <Modal 
        show={showUserProfile} 
        onHide={() => {
          setShowUserProfile(false);
          setProfileUser(null);
        }} 
        size="lg" 
        centered
        className="profile-modal"
      >
        <Modal.Header closeButton className="border-bottom-0 pb-0">
          <Modal.Title className="d-flex align-items-center">
            <i className="bi bi-person-circle me-2 text-primary fs-4"></i>
            <span className="fw-bold fs-5">User Profile</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-0">
          <div className="row g-0 rounded-3 overflow-hidden shadow-sm">
            {/* Left: Profile Summary */}
            <div className="col-md-4 bg-gradient-primary d-flex flex-column align-items-center p-4 border-end">
              <div className="position-relative mb-3">
                {profileUser.avatar ? (
                  <img 
                    src={profileUser.avatar} 
                    alt="Profile" 
                    className="rounded-circle border border-3 border-white shadow-lg"
                    style={{ width: '120px', height: '120px', objectFit: 'cover' }}
                  />
                ) : (
                  <UserInitialsAvatar 
                    name={profileUser.full_name} 
                    size={120} 
                    className="border border-3 border-white shadow-lg"
                  />
                )}
                <div className="position-absolute bottom-0 end-0 bg-white rounded-circle p-1 shadow-sm">
                  <i className="bi bi-patch-check-fill text-primary fs-5"></i>
                </div>
              </div>
              
              <h3 className="h5 text-center fw-bold mb-1 text-white">
                {profileData.company_name || profileUser.full_name || 'Company Name'}
              </h3>
              <p className="mb-2 text-white-80 small text-center">
                <i className="bi bi-envelope me-1"></i> {profileUser.email || 'Email'}
              </p>
              <span className="badge bg-white text-primary fw-normal mb-3 px-3 py-2">
                <i className="bi bi-person-badge me-1"></i> {profileData.position || 'Position'}
              </span>
              
              <div className="w-100 mb-3">
                <button className="btn btn-light w-100 mb-2 rounded-pill shadow-sm">
                  <i className="bi bi-chat-left-text me-2"></i>Send Message
                </button>
              </div>
              
              <div className="w-100 mt-2">
                <div className="d-flex align-items-center mb-3">
                  <div className="me-3 text-white">
                    <i className="bi bi-tag fs-5"></i>
                  </div>
                  <div>
                    <div className="text-white-80 small">Participation Type</div>
                    <div className="fw-medium text-white">{profileData.participation_type || 'N/A'}</div>
                  </div>
                </div>
                
                <div className="d-flex align-items-center mb-3">
                  <div className="me-3 text-white">
                    <i className="bi bi-shop fs-5"></i>
                  </div>
                  <div>
                    <div className="text-white-80 small">Exhibit Booth</div>
                    <div className="fw-medium text-white">{profileData.exhibit_booth || 'N/A'}</div>
                  </div>
                </div>
                
                <div className="d-flex align-items-center mb-3">
                  <div className="me-3 text-white">
                    <i className="bi bi-people fs-5"></i>
                  </div>
                  <div>
                    <div className="text-white-80 small">B2B Interest</div>
                    <div className="fw-medium text-white">
                      {profileUser.b2b_interest && profileUser.b2b_interest.length > 0 
                        ? profileUser.b2b_interest.join(', ') 
                        : 'N/A'}
                    </div>
                  </div>
                </div>
                
                {profileData.b2b_details && (
                  <div className="d-flex align-items-start mb-3">
                    <div className="me-3 text-white">
                      <i className="bi bi-card-text fs-5"></i>
                    </div>
                    <div>
                      <div className="text-white-80 small">B2B Details</div>
                      <div className="fw-medium text-white">{profileData.b2b_details}</div>
                    </div>
                  </div>
                )}
              </div>
            </div>
            
            {/* Right: Data Details */}
            <div className="col-md-8 p-4 bg-white">
              {/* Personal Details */}
              <div className="mb-4">
                <h5 className="fw-bold mb-3 d-flex align-items-center">
                  <i className="bi bi-person-lines-fill text-primary me-2"></i>
                  Personal Details
                </h5>
                <div className="row">
                  <div className="col-sm-6 mb-3">
                    <div className="mb-2">
                      <div className="text-muted small mb-1">Full Name</div>
                      <div className="fw-medium">{profileData.full_name || profileUser.full_name || 'N/A'}</div>
                    </div>
                    <div className="mb-2">
                      <div className="text-muted small mb-1">Email</div>
                      <div className="fw-medium">{profileUser.email || 'N/A'}</div>
                    </div>
                    <div className="mb-2">
                      <div className="text-muted small mb-1">Phone</div>
                      <div className="fw-medium">{profileData.phone || 'N/A'}</div>
                    </div>
                    <div className="mb-2">
                      <div className="text-muted small mb-1">Country</div>
                      <div className="fw-medium">{profileData.country || 'N/A'}</div>
                    </div>
                    <div className="mb-2">
                      <div className="text-muted small mb-1">Position</div>
                      <div className="fw-medium">{profileData.position || 'N/A'}</div>
                    </div>
                  </div>
                  <div className="col-sm-6 mb-3">
                    <div className="mb-2">
                      <div className="text-muted small mb-1">Organization</div>
                      <div className="fw-medium">{profileData.organization || 'N/A'}</div>
                    </div>
                    <div className="mb-2">
                      <div className="text-muted small mb-1">Title</div>
                      <div className="fw-medium">{profileData.title || 'N/A'}</div>
                    </div>
                    <div className="mb-2">
                      <div className="text-muted small mb-1">Comments</div>
                      <div className="fw-medium">{profileData.comments || 'N/A'}</div>
                    </div>
                    <div className="mb-2">
                      <div className="text-muted small mb-1">Sponsorship Interest</div>
                      <div className="fw-medium">{profileData.sponsorship_interest ? 'Yes' : 'No'}</div>
                    </div>
                    <div className="mb-2">
                      <div className="text-muted small mb-1">Need Invoice</div>
                      <div className="fw-medium">{profileData.need_invoice ? 'Yes' : 'No'}</div>
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Company Details */}
              <div className="mb-4">
                <h5 className="fw-bold mb-3 d-flex align-items-center">
                  <i className="bi bi-building text-primary me-2"></i>
                  Company Details
                </h5>
                <div className="row">
                  <div className="col-sm-6 mb-3">
                    <div className="mb-2">
                      <div className="text-muted small mb-1">Company Name</div>
                      <div className="fw-medium">{profileData.company_name || 'N/A'}</div>
                    </div>
                    <div className="mb-2">
                      <div className="text-muted small mb-1">Profile</div>
                      <div className="fw-medium">{profileData.company_profile || 'N/A'}</div>
                    </div>
                    <div className="mb-2">
                      <div className="text-muted small mb-1">Sector</div>
                      <div className="fw-medium">{profileData.company_sector || 'N/A'}</div>
                    </div>
                    <div className="mb-2">
                      <div className="text-muted small mb-1">Address</div>
                      <div className="fw-medium">{profileData.company_address || 'N/A'}</div>
                    </div>
                    <div className="mb-2">
                      <div className="text-muted small mb-1">Phone</div>
                      <div className="fw-medium">{profileData.company_phone || 'N/A'}</div>
                    </div>
                  </div>
                  <div className="col-sm-6 mb-3">
                    <div className="mb-2">
                      <div className="text-muted small mb-1">Website</div>
                      <div className="fw-medium">
                        {profileData.company_website ? (
                          <a href={profileData.company_website} target="_blank" rel="noopener noreferrer" className="text-decoration-none">
                            {profileData.company_website}
                          </a>
                        ) : 'N/A'}
                      </div>
                    </div>
                    <div className="mb-2">
                      <div className="text-muted small mb-1">Social Media</div>
                      <div className="fw-medium">
                        {/* Add social media links here if available */}
                        N/A
                      </div>
                    </div>
                    <div className="mb-2">
                      <div className="text-muted small mb-1">Products & Services</div>
                      <div className="fw-medium">{profileData.products_services || 'N/A'}</div>
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Products Section */}
              {profileProducts.length > 0 && (
                <div className="mb-4">
                  <h5 className="fw-bold mb-3 d-flex align-items-center">
                    <i className="bi bi-box-seam text-primary me-2"></i>
                    Products
                  </h5>
                  <div className="table-responsive">
                    <table className="table table-sm table-hover align-middle">
                      <thead className="bg-light">
                        <tr>
                          <th className="ps-3">Name</th>
                          <th>Description</th>
                          <th className="text-end pe-3">Price</th>
                        </tr>
                      </thead>
                      <tbody>
                        {profileProducts.map((product, i) => (
                          <tr key={i}>
                            <td className="ps-3 fw-medium">{product.product_name}</td>
                            <td className="text-muted">{product.description}</td>
                            <td className="text-end pe-3 fw-medium">${product.selling_price}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
              
              {/* Services Section */}
              {profileServices.length > 0 && (
                <div className="mb-4">
                  <h5 className="fw-bold mb-3 d-flex align-items-center">
                    <i className="bi bi-gear text-primary me-2"></i>
                    Services
                  </h5>
                  <div className="table-responsive">
                    <table className="table table-sm table-hover align-middle">
                      <thead className="bg-light">
                        <tr>
                          <th className="ps-3">Name</th>
                          <th>Description</th>
                          <th className="pe-3">Company</th>
                        </tr>
                      </thead>
                      <tbody>
                        {profileServices.map((service, i) => (
                          <tr key={i}>
                            <td className="ps-3 fw-medium">{service.service_name}</td>
                            <td className="text-muted">{service.service_description}</td>
                            <td className="pe-3 fw-medium">{service.campany_name}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="border-top-0 pt-0">
          <Button 
            variant="outline-secondary" 
            onClick={() => setShowUserProfile(false)}
            className="rounded-pill px-4"
          >
            Close
          </Button>
          <Button 
            variant="primary" 
            onClick={() => {
              if (profileUser.id) {
                setActiveChat(profileUser.id);
                setShowUserProfile(false);
              }
            }}
            className="rounded-pill px-4"
          >
            <i className="bi bi-chat-dots me-2"></i>Start Chat
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  // Render call overlay - REMOVED since we're redirecting to meeting room
  const renderCallOverlay = () => {
    // No longer needed as we redirect to meeting room
    return null;
  };

  // Function to toggle expanded state for a user
  const toggleUserExpanded = (userId) => {
    setUsers(prevUsers => 
      prevUsers.map(user => 
        user.id === userId ? { ...user, expanded: !user.expanded } : user
      )
    );
  };

  return (
    <div className="app">
      <Sidebar />
      <div className="main-content">
        <Header />
        <Content>
          <div className="chat-container">
            <div className="row g-0 h-100">
              <div className="col-md-4 border-end bg-white">
                {/* USERS LIST UI PART - CARD STYLE, SMOOTH & USER FRIENDLY BOOTSTRAP */}
                <div className="users-list h-100 d-flex flex-column bg-white shadow-sm rounded border">
                  {/* Header */}
                  <div className="p-3 border-bottom d-flex justify-content-between align-items-center bg-gradient-primary rounded-top">
                    <h5 className="mb-0 fw-bold text-white">
                      <i className="bi bi-people me-2"></i>Messages
                    </h5>
                    <div>
                      <OverlayTrigger placement="bottom" overlay={<Tooltip>New Chat</Tooltip>}>
                        <button className="btn btn-light rounded-circle me-2" aria-label="New Chat">
                          <RiChatNewLine />
                        </button>
                      </OverlayTrigger>
                      <OverlayTrigger placement="bottom" overlay={<Tooltip>Start Video Meeting</Tooltip>}>
                        <button 
                          className="btn btn-light rounded-circle" 
                          onClick={() => startMeeting(true)} 
                          aria-label="Start Video Meeting"
                        >
                          <FiVideo />
                        </button>
                      </OverlayTrigger>
                    </div>
                  </div>
                  
                  {/* View Mode Selector */}
                  <div className="p-3 border-bottom bg-light">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="d-flex align-items-center">
                        <FiSearch className="me-2" />
                        <input 
                          type="text" 
                          className="form-control"
                          placeholder="Search by name, email, company, B2B interests..."
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                        />
                      </div>
                      
                      <div className="btn-group btn-group-sm ms-2" role="group">
                        <button 
                          type="button" 
                          className={`btn btn-outline-secondary ${listViewMode === 'compact' ? 'active' : ''}`}
                          onClick={() => setListViewMode('compact')}
                          title="Compact View"
                        >
                          <FiList />
                        </button>
                        <button 
                          type="button" 
                          className={`btn btn-outline-secondary ${listViewMode === 'detailed' ? 'active' : ''}`}
                          onClick={() => setListViewMode('detailed')}
                          title="Detailed View"
                        >
                          <FiGrid />
                        </button>
                      </div>
                    </div>
                  </div>
                  
                  {/* Pinned messages */}
                  {pinnedMessages.length > 0 && (
                    <div className="border-bottom bg-light">
                      <button 
                        className="w-100 text-start p-3 d-flex align-items-center justify-content-between border-0 bg-transparent"
                        onClick={() => setShowPinnedMessages(!showPinnedMessages)}
                        style={{fontWeight: 500}}
                      >
                        <span>
                          <BsPinAngleFill className="text-warning me-2" />
                          Pinned Messages ({pinnedMessages.length})
                        </span>
                        <span className="text-muted">{showPinnedMessages ? '▲' : '▼'}</span>
                      </button>
                      {showPinnedMessages && (
                        <div className="px-3 pb-3">
                          {pinnedMessages.map(msg => (
                            <div key={msg.id} className="p-2 bg-white border rounded mb-2">
                              <div className="d-flex justify-content-between align-items-start">
                                <small className="fw-bold">{msg.sender}</small>
                                <button 
                                  className="btn btn-sm p-0"
                                  onClick={() => unpinMessage(msg.id)}
                                  aria-label="Unpin"
                                >
                                  <BsPinAngleFill className="text-warning" />
                                </button>
                              </div>
                              <p className="mb-0 small text-truncate">{msg.text}</p>
                              <small className="text-muted">{formatMessageTime(msg.timestamp)}</small>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  )}

                  {/* User List Card Style - Fixed scrolling issue */}
                  <div className="flex-grow-1 overflow-auto" style={{ maxHeight: 'calc(100vh - 300px)' }}>
                    {loadingUsers ? (
                      <div className="text-center p-4">
                        <div className="spinner-border text-primary" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    ) : userError ? (
                      <div className="alert alert-danger m-3">{userError}</div>
                    ) : (
                      <>
                        {/* Community Group Row */}
                        <div 
                          className={`user-item p-3 border-bottom d-flex align-items-center bg-white ${
                            activeChat === 'Community' 
                              ? "active-user-card border-primary border-3" 
                              : ""
                          } rounded-0`}
                          style={{ cursor: 'pointer'}}
                          onClick={() => setActiveChat('Community')}
                        >
                          <div className="position-relative me-3">
                            <img 
                              src={Logo} 
                              alt="Community" 
                              className="rounded-circle border"
                              width="44"
                              height="44"
                            />
                            <span className="position-absolute bottom-0 end-0 bg-success rounded-circle border border-2 border-white"
                                  style={{ width: '12px', height: '12px' }}></span>
                          </div>
                          <div className="flex-grow-1">
                            <div className="d-flex justify-content-between align-items-center">
                              <h6 className="mb-0">Community Updates</h6>
                              <small className="text-muted">{formatMessageTime(new Date())}</small>
                            </div>
                            <p className="mb-0 text-muted text-truncate" style={{maxWidth: 220}}>
                              {messages.length > 0 ? 
                                `${messages[messages.length-1].sender}: ${messages[messages.length-1].text.substring(0, 20)}...` : 
                                'No messages yet'}
                            </p>
                          </div>
                          {activeChat !== 'Community' && messages.filter(m => !m.read && m.sender !== 'You').length > 0 && (
                            <span className="badge bg-primary rounded-pill ms-2">
                              {messages.filter(m => !m.read && m.sender !== 'You').length}
                            </span>
                          )}
                        </div>

                        {/* Users Card List - Enhanced with full profile data */}
                        <div className="p-2">
                          {filteredUsers && filteredUsers.length > 0 ? (
                            filteredUsers
                              .filter(user => user.email !== userEmail)
                              .map(user => (
                                <UserCard
                                  key={user.id}
                                  user={user}
                                  onlineUsers={onlineUsers}
                                  activeChat={activeChat}
                                  setActiveChat={setActiveChat}
                                  initiateCall={initiateCall}
                                  setProfileUser={setProfileUser}
                                  loadProfileDetails={loadProfileDetails}
                                  setShowUserProfile={setShowUserProfile}
                                  toggleUserExpanded={toggleUserExpanded}
                                />
                              ))
                          ) : (
                            <div className="text-center text-muted py-4">
                              {searchQuery ? "No users match your search" : "No other users found"}
                            </div>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-md-8 d-flex flex-column h-100 bg-light">
                <div className="chat-header p-3 border-bottom d-flex align-items-center bg-white shadow-sm">
                  {activeChat === 'Community' ? (
                    <>
                      <div className="position-relative me-3">
                        <img 
                          src={Logo}
                          alt="Community" 
                          className="rounded-circle"
                          width="50"
                          height="50"
                        />
                        <span className="position-absolute bottom-0 end-0 bg-success rounded-circle border border-2 border-white"
                              style={{ width: '12px', height: '12px' }}></span>
                      </div>
                      <div className="flex-grow-1">
                        <h5 className="mb-0">Community Group</h5>
                        <div className="d-flex align-items-center">
                          <small className="text-muted me-2">
                            <FiUsers className="me-1" /> 15 participants
                          </small>
                          {typingUsers.length > 0 && (
                            <small className="text-primary">
                              {users.find(u => u.id === typingUsers[0])?.full_name} is typing...
                            </small>
                          )}
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div 
                        className="position-relative me-3 cursor-pointer"
                        onClick={() => {
                          const user = users.find(u => u.id === activeChat);
                          if (user) {
                            setProfileUser(user);
                            loadProfileDetails(user.email, user.company_name);
                            setShowUserProfile(true);
                          }
                        }}
                      >
                        {users.find(u => u.id === activeChat)?.avatar ? (
                          <img 
                            src={users.find(u => u.id === activeChat)?.avatar} 
                            alt={users.find(u => u.id === activeChat)?.full_name} 
                            className="rounded-circle"
                            width="50"
                            height="50"
                          />
                        ) : (
                          <UserInitialsAvatar 
                            name={users.find(u => u.id === activeChat)?.full_name} 
                            size={50} 
                          />
                        )}
                        {onlineUsers.includes(activeChat) && (
                          <span className="position-absolute bottom-0 end-0 bg-success rounded-circle border border-2 border-white"
                                style={{ width: '12px', height: '12px' }}></span>
                        )}
                      </div>
                      <div 
                        className="flex-grow-1 cursor-pointer"
                        onClick={() => {
                          const user = users.find(u => u.id === activeChat);
                          if (user) {
                            setProfileUser(user);
                            loadProfileDetails(user.email, user.company_name);
                            setShowUserProfile(true);
                          }
                        }}
                      >
                        <h5 className="mb-0">{users.find(u => u.id === activeChat)?.full_name}</h5>
                        <small className="text-muted">
                          {onlineUsers.includes(activeChat) ? 'Online' : 'Offline'}
                          {isTyping && ' • typing...'}
                        </small>
                      </div>
                    </>
                  )}
                  <div className="d-flex">
                    <OverlayTrigger placement="bottom" overlay={<Tooltip>View Profile</Tooltip>}>
                      <button className="btn btn-light rounded-circle me-2" onClick={() => {
                        const user = users.find(u => u.id === activeChat);
                        if (user) {
                          setProfileUser(user);
                          loadProfileDetails(user.email, user.company_name);
                          setShowUserProfile(true);
                        }
                      }}>
                        <BsPerson />
                      </button>
                    </OverlayTrigger>
                  
                    {activeChat !== 'Community' && (
                      <OverlayTrigger placement="bottom" overlay={<Tooltip>Start Video Call</Tooltip>}>
                        <button 
                          className="btn btn-light rounded-circle me-2" 
                          onClick={() => {
                            const user = users.find(u => u.id === activeChat);
                            if (user) {
                              initiateCall(activeChat);
                            }
                          }}
                        >
                          <FiVideo />
                        </button>
                      </OverlayTrigger>
                    )}
                    <Dropdown>
                      <Dropdown.Toggle variant="light" id="dropdown-chat-actions" className="rounded-circle">
                        <BsThreeDotsVertical />
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item onClick={() => navigator.clipboard.writeText(window.location.href)}>
                          Copy chat link
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => setShowPinnedMessages(true)}>
                          View pinned messages
                        </Dropdown.Item>
                        <Dropdown.Item>
                          Mute notifications
                        </Dropdown.Item>
                        <Dropdown.Divider />
                        <Dropdown.Item className="text-danger">
                          Clear chat
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
                <div className="messages-area flex-grow-1 p-3 overflow-auto position-relative">
                  {loadingMessages ? (
                    <div className="text-center p-4">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading messages...</span>
                      </div>
                    </div>
                  ) : messageError ? (
                    <div className="alert alert-danger m-3">{messageError}</div>
                  ) : !activeChat ? (
                    <div className="text-center text-muted p-4 d-flex flex-column align-items-center justify-content-center h-100">
                      <div className="mb-3">
                        <FiMessageSquare size={48} className="text-primary" />
                      </div>
                      <h5 className="fw-bold mb-2">Welcome to Chat</h5>
                      <p style={{ fontSize: "1.1rem" }}>
                        Select a user or group from the sidebar to start chatting
                      </p>
                    </div>
                  ) : messages.length === 0 ? (
                    <div className="text-center text-muted p-4 d-flex flex-column align-items-center justify-content-center h-100">
                      <div className="mb-3">
                        {activeChat === 'Community' ? (
                          <FiUsers size={48} className="text-primary" />
                        ) : (
                          <FiUser size={48} className="text-primary" />
                        )}
                      </div>
                      <h5 className="fw-bold mb-2">
                        {activeChat === 'Community' 
                          ? "No messages in this group yet" 
                          : "No conversation with this user yet"}
                      </h5>
                      <p style={{ fontSize: "1.1rem" }}>
                        {activeChat === 'Community'
                          ? "Be the first to start the conversation"
                          : "Say hello and start chatting!"}
                      </p>
                      {activeChat === 'Community' && (
                        <div className="d-flex gap-2 mt-3">
                          <button className="btn btn-primary" onClick={() => startMeeting(true)}>
                            <FiVideo className="me-2" /> Start Video Meeting
                          </button>
                          <button className="btn btn-outline-primary" onClick={() => startMeeting(false)}>
                            <FiPhone className="me-2" /> Start Audio Meeting
                          </button>
                        </div>
                      )}
                    </div>
                  ) : (
                    <>
                      {messages.map((message, index) => {
                        const showDate =
                          index === 0 ||
                          new Date(message.timestamp).toDateString() !==
                            new Date(messages[index - 1].timestamp).toDateString();

                        const isCurrentUser = message.sender_email === userEmail;

                        return (
                          <React.Fragment key={message.id}>
                            {showDate && (
                              <div className="text-center my-3">
                                <span className="bg-light px-3 py-1 rounded-pill text-muted small">
                                  {isToday(new Date(message.timestamp))
                                    ? "Today"
                                    : isYesterday(new Date(message.timestamp))
                                    ? "Yesterday"
                                    : format(new Date(message.timestamp), "MMMM d, yyyy")}
                                </span>
                              </div>
                            )}
                            <div
                              className={`message mb-3 d-flex ${
                                isCurrentUser ? "justify-content-end" : "justify-content-start"
                              }`}
                            >
                              {/* Show avatar only for received messages */}
                              {!isCurrentUser && (
                                <OverlayTrigger
                                  placement="right"
                                  delay={{ show: 250, hide: 400 }}
                                  overlay={renderTooltip({ text: message.sender })}
                                >
                                  {message.avatar && message.avatar.includes('ui-avatars.com') ? (
                                    <UserInitialsAvatar
                                      name={message.sender}
                                      size={40}
                                      className="me-2 align-self-end cursor-pointer"
                                      onClick={() => {
                                        const user = users.find(
                                          (u) => u.email === message.sender_email
                                        );
                                        if (user) {
                                          setProfileUser(user);
                                          loadProfileDetails(user.email, user.company_name);
                                          setShowUserProfile(true);
                                        }
                                      }}
                                    />
                                  ) : (
                                    <img
                                      src={message.avatar}
                                      alt={message.sender}
                                      className="rounded-circle me-2 align-self-end cursor-pointer"
                                      width="40"
                                      height="40"
                                      onClick={() => {
                                        const user = users.find(
                                          (u) => u.email === message.sender_email
                                        );
                                        if (user) {
                                          setProfileUser(user);
                                          loadProfileDetails(user.email, user.company_name);
                                          setShowUserProfile(true);
                                        }
                                      }}
                                    />
                                  )}
                                </OverlayTrigger>
                              )}

                              <div className="d-flex flex-column">
                                <div
                                  className={`message-bubble p-3 rounded ${
                                    isCurrentUser ? "bg-primary-subtle text-white" : "bg-white"
                                  } shadow-sm`}
                                >
                                  {/* Show sender name for received messages */}
                                  {!isCurrentUser && (
                                    <small className="d-block fw-bold text-dark mb-1">
                                      {message.sender}
                                      {message.company_name && (
                                        <span className="text-muted small ms-2">
                                          ({message.company_name})
                                        </span>
                                      )}
                                    </small>
                                  )}

                                  <Linkify
                                    as="p"
                                    className="mb-0"
                                    options={{
                                      className: isCurrentUser
                                        ? "text-white"
                                        : "text-primary",
                                      target: "_blank",
                                      rel: "noopener noreferrer",
                                      attributes: {
                                        onClick: (e) => e.stopPropagation(),
                                      },
                                      format: {
                                        url: (value) => {
                                          const shortUrl =
                                            value.length > 30
                                              ? `${value.substring(0, 27)}...`
                                              : value;
                                          return shortUrl;
                                        },
                                      },
                                      nl2br: true,
                                      validate: {
                                        url: (value) =>
                                          /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i.test(value),
                                      },
                                    }}
                                  >
                                    {message.text}
                                  </Linkify>

                                  {/* Call notification handling */}
                                  {message.is_call_notification && message.call_link && (
                                    <div className="mt-2">
                                      <a
                                        href={message.call_link}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className={`btn btn-sm ${
                                          isCurrentUser ? "btn-light" : "btn-primary"
                                        }`}
                                      >
                                        <FiVideo className="me-1" /> Join Call
                                      </a>
                                    </div>
                                  )}
                                </div>
                                <div
                                  className={`d-flex align-items-center mt-1 ${
                                    isCurrentUser
                                      ? "justify-content-end"
                                      : "justify-content-start"
                                  }`}
                                >
                                  <small className="text-muted me-2">
                                    {format(
                                      new Date(message.timestamp),
                                      "h:mm a"
                                    )}
                                  </small>
                                  {isCurrentUser && (
                                    <BsCheck2All
                                      className={message.read ? "text-info" : "text-muted"}
                                    />
                                  )}
                                  <button
                                    className="btn btn-sm p-0 ms-2 text-muted-hover"
                                    onClick={() =>
                                      pinnedMessages.some((m) => m.id === message.id)
                                        ? unpinMessage(message.id)
                                        : pinMessage(message.id)
                                    }
                                  >
                                    {pinnedMessages.some((m) => m.id === message.id) ? (
                                      <BsPinAngleFill className="text-warning" />
                                    ) : (
                                      <BsPinAngle />
                                    )}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </React.Fragment>
                        );
                      })}
                      <div ref={messagesEndRef} />
                    </>
                  )}
                </div>
                <div className="message-input p-3 border-top bg-white shadow-sm">
                  <form onSubmit={handleSendMessage} className="d-flex align-items-center gap-2">
                    <OverlayTrigger placement="top" overlay={<Tooltip>Emoji</Tooltip>}>
                      <button type="button" className="btn btn-light rounded-circle">
                        <MdOutlineEmojiEmotions size={20} />
                      </button>
                    </OverlayTrigger>
                    <OverlayTrigger placement="top" overlay={<Tooltip>Attach File</Tooltip>}>
                      <button type="button" className="btn btn-light rounded-circle">
                        <MdOutlineFileUpload size={20} />
                      </button>
                    </OverlayTrigger>
                    <input 
                      type="text" 
                      className="form-control flex-grow-1 rounded-pill border-0 bg-light" 
                      placeholder="Type a message"
                      value={newMessage}
                      onChange={(e) => {
                        setNewMessage(e.target.value);
                        handleTyping();
                      }}
                      onKeyPress={(e) => e.key === 'Enter' && handleSendMessage(e)}
                      disabled={!activeChat}
                    />
                    {newMessage ? (
                      <OverlayTrigger placement="top" overlay={<Tooltip>Send</Tooltip>}>
                        <button type="submit" className="btn btn-primary rounded-circle">
                          <IoMdSend size={20} />
                        </button>
                      </OverlayTrigger>
                    ) : (
                      <OverlayTrigger placement="top" overlay={<Tooltip>Record Voice</Tooltip>}>
                        <button type="button" className="btn btn-light rounded-circle">
                          <FiMic size={20} />
                        </button>
                      </OverlayTrigger>
                    )}
                  </form>
                </div>
              </div>
            </div>
          </div>
          {renderUserProfile()}
          {renderCallOverlay()}
          <style jsx>{`
            .chat-container {
              height: calc(100vh - 150px);
              background-color: #f8f9fa;
            }
            .users-list {
              background-color: white;
            }
            .user-item {
              cursor: pointer;
              transition: background-color 0.2s;
            }
            .user-item:hover {
              background-color: #f8f9fa;
            }
            .messages-area {
              background-color: #e5ddd5;
              background-image: url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z' fill='%239C92AC' fill-opacity='0.05' fill-rule='evenodd'/%3E%3C/svg%3E");
            }
            .message-bubble {
              max-width: 70%;
              position: relative;
            }
            .message-bubble.bg-primary:after {
              content: '';
              position: absolute;
              right: -10px;
              top: 10px;
              border-width: 10px 0 10px 10px;
              border-style: solid;
              border-color: transparent #007bff;
            }
            .user-card-hover {
              transition: all 0.3s ease;
              border-radius: 8px;
            }
            .user-card-hover:hover {
              box-shadow: 0 8px 16px rgba(0,0,0,0.1);
              transform: translateY(-2px);
            }
            .message-bubble.bg-light:after {
              content: '';
              position: absolute;
              left: -10px;
              top: 10px;
              border-width: 10px 10px 10px 0;
              border-style: solid;
              border-color: transparent #f8f9fa;
            }
            .profile-modal .modal-content {
              border: none;
              box-shadow: 0 5px 20px rgba(0,0,0,0.1);
            }
            .bg-primary-soft {
              background-color: rgba(13, 110, 253, 0.1);
            }
            .bg-gradient-primary {
              background: linear-gradient(135deg, #4361ee 0%, #3f37c9 100%);
            }
            .table-sm td, .table-sm th {
              padding: 0.5rem;
            }
            .user-card-compact {
              border-bottom: 1px solid #f0f0f0;
            }
            .user-card-detailed {
              border-bottom: 1px solid #f0f0f0;
            }
            .user-card-grid {
              border-bottom: 1px solid #f0f0f0;
            }
            .user-grid-details {
              background-color: #f8f9fa;
              border-radius: 6px;
              padding: 10px;
              margin-top: 10px;
            }
            .active-user-card {
              background: linear-gradient(135deg, rgba(13, 110, 253, 0.05) 0%, rgba(13, 110, 253, 0.1) 100%);
              border-left: 4px solid #007bff;
              border-radius: 8px;
              box-shadow: 0 4px 12px rgba(13, 110, 253, 0.15);
              transform: translateY(-1px);
            }
            .active-user-indicator {
              position: absolute;
              top: 0;
              left: 0;
              background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
              color: white;
              padding: 4px 8px;
              border-radius: 0 8px 8px 0;
              font-size: 11px;
              font-weight: 600;
              z-index: 10;
              display: flex;
              align-items: center;
              box-shadow: 0 2px 4px rgba(0,0,0,0.2);
            }
          `}</style>
        </Content>
      </div>
    </div>
  );
}